import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static values = {
    title: String,
    text: String,
    icon: String,
    method: String,
    confirmButtonText: { type: String, default: "Oui, confirmer" },
    cancelButtonText: { type: String, default: "Annuler" }
  }

  connect() {
    // console.log("SweetAlert controller ready.")
  }

  confirmLink(event) {
    event.preventDefault()
    const url = this.element.getAttribute("href") || this.element.dataset.url
    
    if (!url) {
      console.error("Aucune URL trouvée pour la confirmation");
      return;
    }

    Swal.fire({
      title: this.titleValue || "Êtes-vous sûr ?",
      text: this.textValue || "Cette action est irréversible !",
      icon: this.iconValue || "warning",
      showCancelButton: true,
      confirmButtonColor: "#29AD41", // Vert
      cancelButtonColor: "#6E839A", // Gris
      confirmButtonText: this.confirmButtonTextValue || "Oui, confirmer",
      cancelButtonText: this.cancelButtonTextValue || "Annuler"
    }).then((result) => {
      if (result.isConfirmed) {
        this.submitRequest(url)
      }
    })
  }

  submitRequest(url) {
    // Par défaut, POST si aucune méthode n'est spécifiée
    const method = (this.methodValue || "post").toLowerCase();
    
    // Méthode adaptée pour tous les types de requêtes
    if (method === "get") {
      // Pour les requêtes GET, rediriger simplement
      window.location.href = url;
    } else {
      // Pour les autres méthodes (POST, PUT, PATCH, DELETE), soumettre un formulaire
      const form = document.createElement("form");
      form.method = "post"; // Toujours POST pour le formulaire, mais on ajoute _method pour Rails
      form.action = url;
      form.style.display = "none";
      
      // Ajout du token CSRF
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content;
      if (csrfToken) {
        const tokenInput = document.createElement("input");
        tokenInput.type = "hidden";
        tokenInput.name = "authenticity_token";
        tokenInput.value = csrfToken;
        form.appendChild(tokenInput);
      }
      
      // Pour les méthodes autres que POST, ajouter l'input _method
      if (method !== "post") {
        const methodInput = document.createElement("input");
        methodInput.type = "hidden";
        methodInput.name = "_method";
        methodInput.value = method;
        form.appendChild(methodInput);
      }
      
      // Ajouter le format JSON pour les réponses AJAX
      const formatInput = document.createElement("input");
      formatInput.type = "hidden";
      formatInput.name = "format";
      formatInput.value = "json";
      form.appendChild(formatInput);
      
      document.body.appendChild(form);
      form.submit();
      
      // Nettoyer
      setTimeout(() => {
        document.body.removeChild(form);
      }, 100);
    }
  }
}
